import { render, staticRenderFns } from "./etablissement-detail-administration.vue?vue&type=template&id=c07ae616"
import script from "./etablissement-detail-administration.vue?vue&type=script&lang=js"
export * from "./etablissement-detail-administration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports